import sedes from "../constants/sedes";
import horarios from "../constants/horarios";
import { materiasOfertaHoraria as materias } from "../constants/materias";

const Tabla = ({ opciones, smallTitle }) => {
  return opciones && opciones.length > 0 ? (
    <ul>
      {opciones.map(({ sede, materia, horario, horas }) => (
        <li key={`${sede}-${materia}-${horario}`}>
          {sedes[sede]} &#8212; {materias[materia]} &#8212; {horarios[horario]}{" "}
          &#8212; {horas} horas
        </li>
      ))}
    </ul>
  ) : null;
};

export default Tabla;
